import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bool, func, shape } from "prop-types";
import { selectors as fundcorpSelectors } from "reducers/fundcorp";
import * as i18nUtils from "util/i18n";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import PageLoading from "pages/_components/PageLoading";
import TransactionTicket from "pages/_components/TransactionTicket";
import CancelSummaryData from "./CancelSummaryData";

const CancelTicket = ({ summary, dispatch, isDesktop, isSmallDesktop, fetching, embeddedInV3Shell }) => {
    const [showDrawerMobile, setShowDrawerMobile] = useState(false);
    const [fetchingDownload, setFetchingDownload] = useState(false);

    useEffect(() => {
        if (!summary && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        }
    }, [summary, dispatch]);

    const centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ margin: isDesktop && "-0.5rem 2rem" }}>{i18nUtils.get("fund.cancel.ticket.title")}</h1>
        </div>
    );

    const exportPdf = async () => {
        setFetchingDownload(true);
        const FORM_SUMMARY = "fund.cancel.summary";
        const {
            fondoClase,
            fondoNombre,
            cuotapartistaNumero,
            cancelDate,
            creditAccountLabel,
            submitDateTime,
            amountToShow,
        } = summary;
        const bodyData = [
            getGeneralTicketItem(`forms.transaction.ticket.date`, `${submitDateTime}`, "datefulltime"),
            getGeneralTicketItem(
                `forms.transaction.ticket.number`,
                summary?.idTransaction.substring(0, 8).toUpperCase(),
                "string",
            ),
        ];

        bodyData.push(
            getGeneralTicketItem(`${FORM_SUMMARY}.fund.label`, `${fondoNombre}`, "string"),
            getGeneralTicketItem(
                `${FORM_SUMMARY}.subscribeAmount.label`,
                `${amountToShow.quantity}`,
                amountToShow.currency === "USD" ? "amountUSD" : "amountARS",
            ),
            getGeneralTicketItem(`${FORM_SUMMARY}.class.label`, fondoClase, "string"),
            getGeneralTicketItem(`${FORM_SUMMARY}.creditAccount.label`, creditAccountLabel, "string"),
            getGeneralTicketItem(`${FORM_SUMMARY}.shareAccount.label`, cuotapartistaNumero, "string"),
            getGeneralTicketItem(`${FORM_SUMMARY}.date.label`, cancelDate, "date"),
        );

        const ticketData = {
            ticketName: i18nUtils.get("fund.cancel.ticket.title"),
            ticketBody: bodyData,
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18nUtils.get("global.download.success"));

        setFetchingDownload(false);
    };

    const buttonsDetail = () => {
        const buttons = [
            {
                label: "fund.cancel.ticket.goToDesktop",
                bsStyle: "outline",
                onClick: () => dispatch(push(embeddedInV3Shell ? "/v3/dashboard" : "/desktop")),
            },
        ];

        if (summary?.idTransactionStatus !== "SCHEDULED") {
            buttons.push({
                label: "fund.cancel.ticket.goToFundTrade",
                bsStyle: "primary",
                onClick: () => dispatch(push("/fundcorpOperations?opt=movementsAndRequests")),
            });
        }

        return buttons;
    };

    const renderContent = () => {
        const isFinished = summary?.idTransactionStatus === "FINISHED";

        return (
            <>
                {summary && (
                    <TransactionTicket
                        notificationScope="forms"
                        embeddedInV3Shell={embeddedInV3Shell}
                        embeddedV3GoBackPath="/fundcorpOperations"
                        embeddedV3LayoutScopes={["cancelTicket"]}
                        handleClick={exportPdf}
                        handleClickMessage="global.download"
                        uniqueDownload={isFinished}
                        downloadImageWhite={!isDesktop}
                        headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                        centerElement={isDesktop ? undefined : centerContentMobile}
                        hasInlineButtons
                        hideMobileMenu={!isDesktop}
                        summary={summary}
                        fetching={fetching}
                        generateSignFunction
                        ignoreHomeButton
                        buttonsDetail={buttonsDetail()}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        summaryTitle="fund.cancel.ticket.title"
                        showDrawerMobile={showDrawerMobile}
                        closeMobileDrawer={() => setShowDrawerMobile(false)}
                        isFetchingExport={fetchingDownload}>
                        <CancelSummaryData spaceBetween summary={summary} isDesktop={isDesktop} />
                    </TransactionTicket>
                )}
            </>
        );
    };

    return <PageLoading loading={fetching}>{!fetching && renderContent()}</PageLoading>;
};

CancelTicket.propTypes = {
    summary: shape({}).isRequired,
    dispatch: func.isRequired,
    isDesktop: bool.isRequired,
    isSmallDesktop: bool.isRequired,
    fetching: bool.isRequired,
    embeddedInV3Shell: bool,
};

CancelTicket.defaultProps = {
    embeddedInV3Shell: false,
};

const mapStateToProps = (state) => ({
    summary: fundcorpSelectors.getSummary(state),
    fetching: fundcorpSelectors.getFetching(state),
});

export default connect(mapStateToProps)(CancelTicket);
